import API from './config'

export const TitleLocalQuotasAPI = {
    async saveTitleLocalQuotas(obj) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/title_local_quotas/saveTitleLocalQuotas', obj, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async loadAllQuotasTitleById(titleId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/titles/loadAllQuotasTitleById/' + titleId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTitleLocalQuotasTitleByIdAndPeriod(titleId, startDate, endDate) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/title_local_quotas/getTitleLocalQuotasTitleByIdAndPeriod',
                { titleId: titleId, startDate: startDate, endDate: endDate }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getTitleLocalQuotasTitleByIdAndPeriods(titleId, periods) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/title_local_quotas/getTitleLocalQuotasTitleByIdAndPeriods', {
                title_id: titleId,
                periods: periods
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },
}
